import { Message } from '@/types/discover';
import { useChatbotContext } from '../../_context/ChatbotContext';

interface BubbleFeedbackProps {
  data: Message;
}

const BubbleFeedback = ({ data }: BubbleFeedbackProps) => {
  const { messages } = useChatbotContext();
  const isLastMessage = data && messages && messages[messages.length - 1]?.id === data.id;
  // if (!messages || messages.length === 0) return null;
  // const botMessages = messages.filter((msg) => msg.sender === 'bot');
  // if (botMessages.length === 1) return null;
  // const lastBotMessage = botMessages[botMessages.length - 1];
  // if (!lastBotMessage || lastBotMessage.id !== data.id) return null;
  if (!isLastMessage) return null;
  if (data.id === 0) return null;
  if (messages[messages.length - 2]?.action === 'INFO_GATHER') return null;

  return (
    <div className="flex items-center gap-[8px] text-xs text-gr-700">
      오늘 질문 횟수({data.questionRemainCount || 0}/{data.maxQuestionCount || 10})
    </div>
  );
};

export default BubbleFeedback;
